import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormControl, Validators } from '@angular/forms';

export interface BranchTableNoteModalData {
  title: string;
  note?: string;
}

export interface BranchTableNoteModalResult {
  note: string;
}

@Component({
  selector: 'app-branch-table-note-modal',
  templateUrl: './branch-table-note-modal.component.html',
  styleUrls: ['./branch-table-note-modal.component.scss'],
  standalone: false
})
export class BranchTableNoteModalComponent {
  noteControl: UntypedFormControl;

  constructor(
    public dialogRef: MatDialogRef<BranchTableNoteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BranchTableNoteModalData
  ) {
    this.noteControl = new UntypedFormControl(data.note || '', [Validators.required]);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.noteControl.valid) {
      const result: BranchTableNoteModalResult = {
        note: this.noteControl.value.trim()
      };
      this.dialogRef.close(result);
    }
  }

  isValid(): boolean {
    return this.noteControl.valid && this.noteControl.value?.trim().length > 0;
  }
}
